import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { apiGet, apiPost } from '../../../API/Api_Url';
import { FaEdit, FaEye, FaPlus, FaTrash, FaTrashAlt } from 'react-icons/fa';
import { Calendar, CheckCircle, DollarSign, MapPin, Menu, MoreVertical, Package, Truck, XCircle } from 'lucide-react';
import { toast } from 'react-toastify';
import SuppilerAddQuotationModel from '../../Modal/SuppilerAddQuotationModel';
import { MenuButton, MenuItem } from "@headlessui/react";
import SupplierUpdateQuotationModal from '../../Modal/SupplierUpdateQuotationModal';
import SupplierDeleteQuotationModal from '../../Modal/SupplierDeleteQuotationModal';

function AllPendingMaterialRequest({ ProUserdata }) {
    const navigate = useNavigate();
    const [MaterialRequest, setMaterialRequest] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllPendingMaterialRequest = async () => {
        try {
            const State = ProUserdata?.State || "";
            const City = ProUserdata?.City || "";

            setIsUploading(true);
            const response = await apiGet(
                `api/material-supplier/GetAllPendingMaterialRequest?State=${encodeURIComponent(State)}&City=${encodeURIComponent(City)}`
            );

            if (response?.data) {
                setMaterialRequest(response.data);
            } else {
                setMaterialRequest([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setMaterialRequest([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        if (ProUserdata) {
            GetAllPendingMaterialRequest();
        }
    }, [ProUserdata]);


    const getStatusColor = (status) => {
        switch (status) {
            case 'Pending':
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case 'Accepted':
                return 'bg-green-100 text-green-800 border-green-200';
            case 'Rejected':
                return 'bg-red-100 text-red-800 border-red-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const [AddQuotationModel, setAddQuotationModel] = useState(false);
    const [SelectedReq, setSelectedReq] = useState(null);

    const OpenAddQuotationModel = (req) => {
        setSelectedReq(req)
        setAddQuotationModel(true)
    }

    const CloseAddQuotationModel = () => {
        setSelectedReq(null)
        setAddQuotationModel(false)
    }


    const [SelectedQuotation, setSelectedQuotation] = useState(null);
    const [UpdateQuotationModel, setUpdateQuotationModel] = useState(false);

    const OpenUpdateQuotationModel = (req) => {
        setUpdateQuotationModel(true)
        setSelectedQuotation(req)
    }

    const CloseUpdateQuotationModel = () => {
        setUpdateQuotationModel(false)
        setSelectedQuotation(null)
    }

    const [DeleteQuotationModel, setDeleteQuotationModel] = useState(false);

    const OpendeleteQuotationModel = (req) => {
        setSelectedQuotation(req)
        setDeleteQuotationModel(true)
    }

    const CloseDeleteQuotationModel = () => {
        setDeleteQuotationModel(false)
        setSelectedQuotation(null)
    }

    const [Quotation, setQuotation] = useState(null);
    const [QuotationError, setQuotationError] = useState(null);
    const [IsQuotationLoading, setIsQuotationLoading] = useState(false);

    const GetMybidOnMaterialRequest = async (id) => {
        try {
            setIsQuotationLoading(true);
            setQuotation(null);
            setQuotationError(null);

            const response = await apiGet(`api/material-supplier/GetMybidOnMaterialRequest/${id}`);

            if (response?.statusCode === 200) {
                setQuotation(response?.data);
            } else {
                setQuotationError(response?.message || "No Quotation found");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setQuotationError("Error fetching Quotation");
        } finally {
            setIsQuotationLoading(false);
        }
    };


    const [expandedJob, setExpandedJob] = useState(null);

    const toggleQuotations = async (reqId) => {
        if (expandedJob === reqId) {
            setExpandedJob(null);
            setQuotation([]);
        } else {
            await GetMybidOnMaterialRequest(reqId);
            setExpandedJob(reqId);
        }
    };

    return (
        <div className="p-6 bg-gradient-to-br from-blue-50 to-indigo-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <div className="mb-8 flex flex-col md:flex-row md:items-center md:justify-between">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 mb-1 md:mb-0">
                            All Pending Material Requests
                        </h1>
                        <p className="text-gray-600">Manage and track All Material Requests</p>
                    </div>

                </div>

                {isUploading ? (
                    <div className="flex items-center justify-center py-20">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                        <p className="ml-4 text-gray-600">Loading your projects...</p>
                    </div>
                ) : MaterialRequest?.length === 0 ? (
                    <div className="text-center py-20">
                        <p className="text-xl text-gray-500">No Material Requests found.</p>
                        <p className="text-gray-400 mt-2">Create your first job post to get started.</p>
                    </div>
                ) : (
                    <div className="grid gap-6 grid-cols-1">
                        {MaterialRequest?.map((req) => (
                            <div key={req?._id} className="bg-white rounded-2xl shadow-lg p-6">
                                <div className="flex justify-between items-start mb-4">
                                    <h3 className="text-xl font-bold text-gray-900">
                                        Material Request #{req?._id?.slice(-6)}
                                    </h3>
                                    <span
                                        className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                            req?.Status
                                        )}`}
                                    >
                                        {req?.Status}
                                    </span>
                                </div>
                                {req?.location && (
                                    <div className="flex items-start text-gray-600 mb-4">
                                        <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                        <p className="text-sm">
                                            {req?.location?.Address}, {req?.location?.City},{" "}
                                            {req?.location?.State}
                                        </p>
                                    </div>
                                )}
                                <div className="flex items-center text-gray-700 text-sm mb-3">
                                    <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                    <p>
                                        <span className="font-medium">Delivery Date:</span>{" "}
                                        {formatDate(req?.deliveryDate)}
                                    </p>
                                </div>
                                <div className="mt-4">
                                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center">
                                        <Package className="h-4 w-4 mr-2 text-green-500" />
                                        Material Items
                                    </h4>
                                    <div className="space-y-3">
                                        {req?.MaterialItems?.map((item, i) => (
                                            <div key={i} className="bg-gray-50 border border-gray-200 p-4 rounded-xl flex flex-col sm:flex-row sm:items-center justify-between">
                                                <div>
                                                    <p className="text-sm font-semibold text-gray-800">
                                                        {item?.materialName}
                                                    </p>

                                                    <p className="text-xs text-gray-500">
                                                        Qty: {item?.quantity} {item?.unit} | Specs: {item?.specifications}
                                                    </p>

                                                    {item?.brandPreference && (
                                                        <p className="text-xs text-blue-600 font-medium mt-1">
                                                            Brand Preference: {item?.brandPreference}
                                                        </p>
                                                    )}
                                                </div>
                                                <div className="flex flex-wrap gap-2 mt-2 sm:mt-0">
                                                    <span className="bg-gray-200 text-gray-700 text-xs px-3 py-1 rounded-full shadow-sm">
                                                        {item?.unit}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                    <span className="flex items-center">
                                        <Calendar className="h-4 w-4 mr-1" />
                                        Created: {formatDate(req?.createdAt)}
                                    </span>
                                    <div className="flex items-center gap-2">
                                    </div>
                                    <button
                                        onClick={() => toggleQuotations(req?._id)}
                                        className="mt-3 text-sm text-blue-600 hover:underline flex items-center gap-2"
                                        disabled={IsQuotationLoading}
                                    >
                                        {IsQuotationLoading && expandedJob === req?._id ? (
                                            <>
                                                <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                                                <span>Loading...</span>
                                            </>
                                        ) : expandedJob === req?._id ? (
                                            "Hide My Quotation"
                                        ) : (
                                            "Show My Quotation"
                                        )}
                                    </button>
                                </div>
                                {expandedJob === req?._id && (
                                    <div className="mt-3 border-t pt-3">
                                        {IsQuotationLoading ? (
                                            <p className="text-gray-500 text-sm">Loading Quotation...</p>
                                        ) : Quotation ? (
                                            <div className="bg-white rounded-xl shadow-md p-4 border border-gray-200">
                                                <h4 className="text-lg font-semibold text-gray-800 mb-3">
                                                    My Quotation
                                                </h4>
                                                <div className="space-y-3">
                                                    {Quotation?.QuotedItems?.map((item) => (
                                                        <div
                                                            key={item?._id}
                                                            className="bg-gray-50 p-3 rounded-lg border shadow-sm"
                                                        >
                                                            <h5 className="font-medium text-gray-700 text-base mb-1">
                                                                {item?.materialName}
                                                            </h5>
                                                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 text-xs">
                                                                <div>
                                                                    <span className="font-medium text-gray-600">Qty:</span>{" "}
                                                                    {item?.quantity} {item?.unit}
                                                                </div>
                                                                <div>
                                                                    <span className="font-medium text-gray-600">Price/Unit:</span>{" "}
                                                                    ₹{item?.pricePerUnit}
                                                                </div>
                                                                <div>
                                                                    <span className="font-medium text-gray-600">Total:</span>{" "}
                                                                    ₹{item?.totalPrice}
                                                                </div>
                                                                <div>
                                                                    <span className="font-medium text-gray-600">Brand:</span>{" "}
                                                                    {item?.brand || "-"}
                                                                </div>
                                                                <div className="col-span-2">
                                                                    <span className="font-medium text-gray-600">
                                                                        Specifications:
                                                                    </span>{" "}
                                                                    {item?.specifications || "-"}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="mt-4 bg-gray-50 p-3 rounded-lg border">
                                                    <h5 className="font-medium text-gray-700 mb-2 text-base">
                                                        Quotation Details
                                                    </h5>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
                                                        <div>
                                                            <span className="font-medium text-gray-600">GST:</span>{" "}
                                                            {Quotation?.GST}%
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Delivery:</span>{" "}
                                                            {Quotation?.DeliveryTime}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Credit Terms:</span>{" "}
                                                            {Quotation?.CreditTerms}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Note:</span>{" "}
                                                            {Quotation?.Note}
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Status:</span>{" "}
                                                            <span
                                                                className={`px-2 py-0.5 rounded-md text-xs font-medium ${Quotation?.Status === "Pending"
                                                                    ? "bg-yellow-100 text-yellow-700"
                                                                    : Quotation?.Status === "Approved"
                                                                        ? "bg-green-100 text-green-700"
                                                                        : "bg-red-100 text-red-700"
                                                                    }`}
                                                            >
                                                                {Quotation?.Status}
                                                            </span>
                                                        </div>
                                                        <div>
                                                            <span className="font-medium text-gray-600">Created:</span>{" "}
                                                            {new Date(Quotation?.createdAt).toLocaleString()}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-4 flex justify-end gap-3">
                                                    <button
                                                        onClick={() => OpenUpdateQuotationModel(Quotation)}
                                                        className="flex items-center gap-1 px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
                                                    >
                                                        <FaEdit className="text-xs" /> Update
                                                    </button>
                                                    <button
                                                        onClick={() => OpendeleteQuotationModel(Quotation)}
                                                        className="flex items-center gap-1 px-3 py-1.5 bg-red-600 text-white text-sm rounded-md hover:bg-red-700 transition"
                                                    >
                                                        <FaTrash className="text-xs" /> Delete
                                                    </button>
                                                </div>
                                            </div>
                                        ) : QuotationError ? (
                                            <button
                                                onClick={() => OpenAddQuotationModel(req)}
                                                className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700"
                                            >
                                                Create Quotation
                                            </button>
                                        ) : null}
                                    </div>
                                )}


                            </div>
                        ))}
                    </div>
                )}
            </div>
            <SuppilerAddQuotationModel
                isOpen={AddQuotationModel}
                onClose={CloseAddQuotationModel}
                RequestData={SelectedReq}
                GetAllPendingMaterialRequest={GetAllPendingMaterialRequest}
                setExpandedJob={setExpandedJob}
            />
            <SupplierUpdateQuotationModal
                isOpen={UpdateQuotationModel}
                onClose={CloseUpdateQuotationModel}
                quotation={SelectedQuotation}
                GetAllPendingMaterialRequest={GetAllPendingMaterialRequest}
                setExpandedJob={setExpandedJob}
            />
            <SupplierDeleteQuotationModal
                isOpen={DeleteQuotationModel}
                onClose={CloseDeleteQuotationModel}
                quotation={SelectedQuotation}
                GetAllPendingMaterialRequest={GetAllPendingMaterialRequest}
                setExpandedJob={setExpandedJob}
            />


        </div>
    )
}

export default AllPendingMaterialRequest